import {IconProps} from "./types";

export const DurationIcon = ({fill}: IconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM8.8001 4.8001C8.8001 4.35827 8.44193 4.0001 8.0001 4.0001C7.55827 4.0001 7.2001 4.35827 7.2001 4.8001V8.0001C7.2001 8.21227 7.28438 8.41575 7.43441 8.56578L9.69715 10.8285C10.0096 11.1409 10.5161 11.1409 10.8285 10.8285C11.1409 10.5161 11.1409 10.0096 10.8285 9.69715L8.8001 7.66873V4.8001Z"
        fill={fill || "#6B7280"}
      />
    </svg>
  );
};
